

import moment from 'moment';
import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import zaloRepository from "@/services/ZaloRepository";
import {FilterMatchMode} from "primevue/api";
import {Ds_Cls} from "@/models/ds_Cls";
import {FileDetail} from "@/models/fileDetail.models";
import axios from "axios";
import {Cls} from "@/models/cls";
import VueQrcodeReader from 'vue-qrcode-reader';
import { StreamBarcodeReader } from '@teckel/vue-barcode-reader'


// import { StreamBarcodeReader } from "vue-barcode-reader";



export default {
  components: { StreamBarcodeReader },
  methods: {
    onDetect(detectedCodes) {
      console.log("#####$$$$$$$$$$ onDetect: " );
      console.log(detectedCodes)
  //result.value = JSON.stringify(detectedCodes.map((code) => code.rawValue))
},
//     onResult(result: Result | undefined) {
//       console.log("#####$$$$$$$$$$ onDetect: " );
// }
  },
  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const maYTe = ref("");
    const listCLS = ref([] as Ds_Cls[]);
    const listCLSChuaThucHien = ref([] as Ds_Cls[]);
    const listCLSDaThucHien = ref([] as Ds_Cls[]);
    const listFileCls = ref([] as Cls[]);
    const ngaySinh = ref("")
    const permissionCLS = ref(false);

    if((store.state.permission == 'cls')){
      permissionCLS.value = true;
    }

    const contentTrangThai = (id) =>{

      const st = ref('');
      console.log('########################$$$$$$ contentTrangThai id: ' + id);
      listCLS.value.forEach(x => {
        //11,18,13,10
        // CHUAKETQUA
        // DANGTHUCHIEN
        // HOANTAT
        // DALAYMAU
        if(x.dvyeucaU_ID == id) {
          console.log('########################$$$$$$ contentTrangThai x: ' + JSON.stringify(x));
          if ((x.nhomdichvU_ID == 11) || (x.nhomdichvU_ID == 18) || (x.nhomdichvU_ID == 13) || (x.nhomdichvU_ID == 10)
              || (x.nhomdichvU_ID == 1) || (x.nhomdichvU_ID == 9)) {
            if (x.trangthai == 'CHUAKETQUA') st.value = 'CHƯA LẤY MẪU';
            else if (x.trangthai == 'DALAYMAU') st.value = 'ĐÃ LẤY MẪU';
            else if (x.trangthai == 'HOANTAT') st.value = 'ĐÃ CÓ KẾT QUẢ';
            else st.value = '';
          } else {
            if (x.trangthai == 'CHUAKETQUA' ) {
              if(x.pacS_REPORT != '1')
              st.value = 'CHƯA THỰC HIỆN';
              else
              st.value = 'ĐÃ THỰC HIỆN';
            }
            else if ((x.trangthai == 'DACHUP') || (x.trangthai == 'CHOXACNHAN')) st.value = 'ĐÃ THỰC HIỆN';
            else if (x.trangthai == 'HOANTAT') st.value = 'ĐÃ CÓ KẾT QUẢ';
            else st.value = '';
          }
        }
      })

      return st.value;
    }

    const loadListCls = () => {
      loadingBar.value = true;
      console.log("#####$$$$$$$$$$ loadListCls: " );
      zaloRepository.getDanhSachCls(maYTe.value)
          .then((response) => {
            loadingBar.value = false;
            console.log("#####$$$$$$$$$$ loadListCls 0000000: " );
            listCLS.value = response.data;
            maYTe.value='';
            listCLS.value.forEach(x => {
              x.hientrang = contentTrangThai(x.dvyeucaU_ID);
              console.log('########################$$$$$$ contentTrangThai x.hientrang: ' + x.hientrang);
            })
            listCLSChuaThucHien.value = listCLS.value.filter(x => (x.trangthai == 'CHUAKETQUA')&&(x.pacS_REPORT != '1'));
            listCLSDaThucHien.value = listCLS.value.filter(x => (x.trangthai != 'CHUAKETQUA')||((x.trangthai == 'CHUAKETQUA')&&(x.pacS_REPORT == '1')));

            console.log("#####$$$$$$$$$$ loadListCls listCLS: " + JSON.stringify(listCLS.value));
            console.log("#####$$$$$$$$$$ loadListCls listCLSChuaThucHien: " + JSON.stringify(listCLSChuaThucHien.value));
            console.log("#####$$$$$$$$$$ loadListCls listCLSDaThucHien: " + JSON.stringify(listCLSDaThucHien.value));
            console.log("#####$$$$$$$$$$ loadListCls listCLS.value.length: " + listCLS.value.length);
            console.log("#####$$$$$$$$$$ loadListCls listCLSChuaThucHien.value.length: " + listCLSChuaThucHien.value.length);

            if(listCLS.value.length < 1){
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:'Bệnh nhân không có chỉ định cận lâm sàn',
                life: 2000
              });
            }

            if(listCLSChuaThucHien.value.length > 0)
            {
              console.log("#####$$$$$$$$$$ loadListCls 1111111: ");
              toast.add({
                  severity: 'warn',
                  summary: 'Chỉ định cận lâm sàn',
                  detail:'Bệnh nhân còn ' + listCLSChuaThucHien.value.length + ' chỉ định CLS chưa thực hiện',
                  life: 4000
                });
            }
            else if(listCLS.value.length > 0)
            {
              console.log("#####$$$$$$$$$$ loadListCls 222222: ");
              toast.add({
                severity: 'info',
                summary: 'Chỉ định cận lâm sàn',
                detail:'Bệnh nhân hoàn thành tất cả chỉ định CLS.',
                life: 4000
              });
            }

            if(listCLS.value[0].ngaysinh != null)
            {
              ngaySinh.value = formatDate(listCLS.value[0].ngaysinh);
            }
            console.log("#####$$$$$$$$$$ listCLS.value.length aaaa: ");

          })
          .catch(err => {
            loadingBar.value = false;
            console.log("#####$$$$$$$$$$ loadListCls 1111111: " );
            console.log("#####$$$$$$$$$$ loadListCls 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ loadListCls 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatDateTime = (date) => {
      // console.log("@@@@@@@@@################ formatDateTime date: " + JSON.stringify(date));
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm:ss DD/MM/YYYY');
    };

    const formatDate = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + JSON.stringify(date.value));
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('DD/MM/YYYY');
    };
    const listLink = ref([] as string[]);
    let listFileName = ref([] as FileDetail[]);
    const loadingBar = ref(false);
    const upload = () => {
      {
        // listCLS.value[0].sodienthoai = "0905333122"; // debug
        // listCLS.value[0].sodienthoai = "0905123456"; // debug
        listLink.value = [];
        var files = new FormData();
        listFileName.value.forEach(x =>
        {
          files.append("formFiles", x.value, x.nameFile);
        });
        loadingBar.value = true;
        axios.defaults.headers.common = {'Authorization': `Bearer ${store.state.token}`}
        axios.post(`../api/File/UploadFileCLS/${listCLS.value[0].sodienthoai}/${maYTe.value}`, files,
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
              }
            }).then(response => {

          loadingBar.value = false;
          listFileName.value = [];
          if(response.data.status) {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Tải kết quả thành công',
              life: 2000
            });
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          }
          else{
            toast.add({
              severity: 'warn',
              summary: 'Lỗi',
              detail:response.data.log,
              life: 2500
            });
          }
        })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })});
      }
    };

    const fileChange = (fileList) => {
      var leng = fileList.length;
      for (var i = 0; i < leng; i++)
      {
        var filetemp = ref({} as FileDetail);
        filetemp.value.nameFile = fileList[i].name;
        filetemp.value.value = fileList[i];
        listFileName.value.push(filetemp.value);
      }
    };

    const sendFileResult = (id: number) => {
      console.log("#####$$$$$$$$$$ sendResult: " );
      zaloRepository.sendResult(id)
          .then((response) => {
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          })
          .catch(err => {
            console.log("#####$$$$$$$$$$ sendFileResult 1111111: " );
            console.log("#####$$$$$$$$$$ sendFileResult 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ sendFileResult 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }



    const isLoading = ref<boolean>(false)
    function onLoading(loading: boolean) {
      isLoading.value = loading
    }

    const barcodeFormats = ref({
      aztec: false,
          code_128: true,
          code_39: false,
          code_93: false,
          codabar: false,
          databar: false,
          databar_expanded: false,
          data_matrix: false,
          dx_film_edge: false,
          ean_13: false,
          ean_8: false,
          itf: false,
          maxi_code: false,
          micro_qr_code: false,
          pdf417: false,
          qr_code: true,
          rm_qr_code: false,
          upc_a: true,
          upc_e: false,
          linear_codes: false,
          matrix_codes: false
    })
    const selectedBarcodeFormats = computed(() => {
          return Object.keys(barcodeFormats.value).filter((format) => barcodeFormats.value[format])
        })

    const decodedText = ref('')
    const openCamera = ref(false);

    const onDecode = (result) => {
      console.log('onDecode #############')
      console.log('onDecode ############# result: ' + result);
      openCamera.value = false;
      maYTe.value = result;
      loadListCls();
    }

    const onLoaded = () => {
      console.log('loaded')
    }
    const scanBarcode = () =>{
      openCamera.value = true;
      maYTe.value = "";
    }
    const deleteData = () => {
      listCLS.value = [];
      listCLSChuaThucHien.value = [];
      listCLSDaThucHien.value = [];
      maYTe.value="";
    }



    return {
      scanBarcode,
      openCamera,
      decodedText,
      onDecode,
      error,
      filters,
      clearFilter,
      initFilters,
      maYTe,
      formatDateTime,
      listCLS,
      loadListCls,
      ngaySinh,
      upload,
      listLink,
      listFileName,
      loadingBar,
      fileChange,
      listFileCls,
      sendFileResult,
      permissionCLS,
      //onDecode,
      onLoaded,
      isLoading,
      onLoading,
      //onDetect,
      selectedBarcodeFormats,
      listCLSChuaThucHien,
      listCLSDaThucHien,
      deleteData,
      contentTrangThai,
    }
  }
}

